import { encodeGetParams } from "../helper/Encypt";
import { apiUrl, appRelease } from "../helper/ApiUrl";
import { Get,mediaGet} from "../common/httpRestServices";

/**
 * custom release org details get
 * name and id get
 */
export const orgDetailsFetch = (obj = {}) => {
    const { data = {} } = obj || {};
    const queryString = data ? encodeGetParams(data) : "";
    return Get(`${apiUrl}${appRelease.getOrgDetails}${queryString}`, true);
};

export const downloadSDKandDOCservice = (obj = {}) => {
    const { data: { fileToken = "" } = {} } = obj || {};
    return mediaGet(`${apiUrl}${appRelease.mediaDownloadUrl}${fileToken}`, true);
};
